// extracted by mini-css-extract-plugin
module.exports = {"unauthorized-chart":"unauthorized-chart_unauthorized-chart__2dhLi","unauthorized-chart__title":"unauthorized-chart_unauthorized-chart__title__3GuRy"};